export const encodeQueryFilter = (filter: any): string => {
    return encodeURIComponent(JSON.stringify(filter));
};
